import React from "react";

function PasswordReset() {
  return (
    <div className="container" style={{ marginTop: "5rem" }}>
      <h3>Resetear Password - FUNCIONALIDAD PENDIENTE!</h3>
      <hr />
      <form action="#">
        <div className="form-group pb-4">
          <label for="exampleInputEmail1">Usuario</label>
          <input type="text" className="form-control" id="userName" placeholder="usuario" />
        </div>
        <div className="form-group pb-4">
          <label for="exampleInputEmail1">Email </label>
          <input
            type="email"
            className="form-control"
            id="email"
            aria-describedby="emailHelp"
            placeholder="Ingrese su email"
          />
          <small id="emailHelp" className="form-text text-muted">
            Nunca compartas tu email con nadie.
          </small>
        </div>
        <div className="form-group pb-4">
          <label for="exampleInputPassword1">Nuevo Password</label>
          <input
            type="password"
            className="form-control"
            id="exampleInputPassword1"
            placeholder="Password"
          />
        </div>
        <div className="form-group pb-4">
          <label for="passswordRepeat">Repite el nuevo password</label>
          <input
            type="password"
            className="form-control"
            id="passswordRepeat"
            placeholder="Password"
          />
        </div>

        <button type="submit" class="btn btn-primary">
          Resetear
        </button>
      </form>
    </div>
  );
}

export default PasswordReset;
